import { twMerge } from "tailwind-merge";

import bannerBg from "../assets/banner-bg.jpg";

type Props = {
  className?: string;
};

export const Banner = (props: Props) => {
  const { className } = props;
  return (
    <div
      className={twMerge(
        "flex flex-col rounded-xl bg-cover bg-center bg-no-repeat px-6 py-5 text-white",
        className
      )}
      style={{
        backgroundImage: `url(${bannerBg})`,
      }}
    >
      <h3 className="flex text-lg leading-7 font-semibold">Earn 215% APR</h3>
      <p className="mt-1 text-xs leading-[18px]">by staking your GNET</p>
    </div>
  );
};
